// ═══════════════════════════════════════════════════════════════
// RollCall — Module Layout with sub-navigation
// ═══════════════════════════════════════════════════════════════

import { Outlet, useLocation } from 'react-router-dom';
import {
  IconLayoutDashboard, IconCalendarEvent, IconUsers,
  IconLogin, IconChartBar, IconFileText, IconToolsKitchen2, IconHistory,
} from '@tabler/icons-react';
import { useFilteredNav } from '../../hooks/useFilteredNav';
import type { NavItem } from '../../types/nav';
import { brand } from '../../lib/colors';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import ModuleNav from '../../components/layout/ModuleNav';

const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', path: '/rollcall', icon: IconLayoutDashboard, exact: true },
  { label: 'Events', path: '/rollcall/events', icon: IconCalendarEvent },
  { label: 'Personnel', path: '/rollcall/personnel', icon: IconUsers },
  { label: 'Check-In', path: '/rollcall/checkin', icon: IconLogin },
  { label: 'Meals', path: '/rollcall/meals', icon: IconToolsKitchen2, minLevel: 'editor' },
  { label: 'History', path: '/rollcall/history', icon: IconHistory, minLevel: 'editor' },
  { label: 'Analytics', path: '/rollcall/analytics', icon: IconChartBar, minLevel: 'editor' },
  { label: 'Reports', path: '/rollcall/reports', icon: IconFileText, minLevel: 'editor' },
];

export default function RollCallLayout() {
  const { pathname } = useLocation();
  const visibleItems = useFilteredNav('rollcall', NAV_ITEMS);

  const isDetail = pathname.match(/\/rollcall\/event\/\d/) ||
    pathname.match(/\/rollcall\/personnel\/\d/) ||
    pathname.endsWith('/badges') ||
    pathname.endsWith('/import');

  const currentPage = NAV_ITEMS.find(item =>
    item.exact ? pathname === item.path : pathname.startsWith(item.path)
  );

  return (
    <div style={{ padding: '24px' }}>
      {!isDetail && (
        <>
          <Breadcrumbs
            items={[
              { label: 'Hub', to: '/' },
              { label: 'RollCall', to: '/rollcall' },
              ...(currentPage && currentPage.path !== '/rollcall' ? [{ label: currentPage.label }] : []),
            ]}
          />
          <ModuleNav items={visibleItems} accentColor={brand.blurple} />
        </>
      )}
      <Outlet />
    </div>
  );
}
